import PropTypes from 'prop-types';

export const fieldsPropType = PropTypes.shape({
  payer: PropTypes.shape({
    label: PropTypes.string,
  }),
  kdb: PropTypes.shape({
    label: PropTypes.string,
  }),
  proportion: PropTypes.shape({
    label: PropTypes.string,
  }),
  dimension: PropTypes.shape({
    label: PropTypes.string,
  }),
});

export default fieldsPropType;
